import TranslationHelper from '../../utils/TranslationHelper'

class RoomAllocationsControl {
    constructor(el, form) {
        this.onChange = null;
        this.el = el ? el : document.querySelector('[data-room-allocation]')
        this.roomAllocations = this.el.querySelectorAll('[data-room-allocation-allocations]')
        this.roomAllocationValue = this.el.querySelector('[data-room-allocation-value]')
        this.addRoom = this.el.querySelector('[data-room-allocation-add-room]')
        this.removeRoom = this.el.querySelectorAll('[data-room-allocation-remove-room]')
        this.form = form ? form : this.el

        this.config = JSON.parse(this.el.dataset.roomAllocation || '{}')
        this.TranslationHelper = new TranslationHelper(this.config.translations || {})

        // vars
        this.nbrOfAdditionalRooms = 0

        this.dataStore = [
            {
                adults: 2,
                //nbrOfChildren: 0,
                children: []
            }
        ]
        this.init()
    }

    init() {

        this.form.addEventListener('input', (e) => this.updateUI())

        this.addRoom.addEventListener('click', (e) => {
            e.preventDefault()
            this.nbrOfAdditionalRooms++
            this.updateRoomAllocations()
        })

        this.removeRoom.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                this.nbrOfAdditionalRooms--
                this.updateRoomAllocations()
            })
        })

    }

    // Set a change listener
    setChangeListener(callback) {
        this.onChange = callback;
    }

    updateRoomAllocations() {
        this.roomAllocations.forEach((roomAllocation, index) => {
            roomAllocation.disabled = this.nbrOfAdditionalRooms < index
            roomAllocation.classList.toggle('controls__room-allocation--last', this.nbrOfAdditionalRooms == index)
        })

        this.addRoom.disabled = this.nbrOfAdditionalRooms >= (this.roomAllocations.length - 1)
        this.form.dispatchEvent(new Event('input', { bubbles: true }))
    }

    updateUI() {
        this.updateDataStore()
        this.roomAllocationValue.innerText = [
            this.TranslationHelper.t(['{nbr} Adult', '{nbr} Adults'], {}, this.dataStore.reduce((acc, allocations) => acc + allocations.adults, 0)),
            this.TranslationHelper.t(['{nbr} Child', '{nbr} Children'], {}, this.dataStore.reduce((acc, allocations) => acc + allocations.children.length, 0)),
            this.TranslationHelper.t(['{nbr} Room', '{nbr} Rooms'], {}, this.dataStore.length)
        ].filter(e => e).join(' · ')


        if (this.onChange) {
            this.onChange({ dataStore: this.dataStore });
        }


        this.toggleAgeSelect()
    }

    toggleAgeSelect() {

        this.roomAllocations.forEach((roomAllocation, index) => {

            // update children age selects
            roomAllocation.querySelectorAll('[data-room-allocation-child-age]').forEach((childAgeSelect, ageIndex) => {
                // console.log(childAgeSelect, this.dataStore[index].nbrOfChildren);
                const toggle = Boolean(this.dataStore?.[index] && this.dataStore[index].children.length < (ageIndex + 1))
                if (toggle) {
                    childAgeSelect.value = ''
                }

                childAgeSelect.disabled = toggle
                childAgeSelect.required = !toggle
            })

        })
    }

    updateDataStore() {
        // reset room allocations
        this.dataStore = []

        const formData = new FormData(this.form)

        // get the allocations
        for (const [key, value] of formData.entries()) {
            const match = key.match(/^allocations\[(\d+)]\[(\w+(?:-\w+)?)\](?:\[(\d+)\])?$/)
            if (match) {
                const [, index, field, key] = match

                this.dataStore[index] ??= {}
                if (field == 'children') {
                    this.dataStore[index][field] ??= []
                    if (value && this.dataStore[index][field][key]) {
                        // update the age by index
                        this.dataStore[index][field][key] = parseInt(value)
                    }
                } else if (field == 'nbrOfChildren') {
                    // create empty array to store the ages
                    this.dataStore[index]['children'] ??= []
                    this.dataStore[index]['children'].length = value
                    this.dataStore[index]['children'].fill(true)

                } else {
                    this.dataStore[index][field] = parseInt(value)
                }
            }
        }

    }

    getGuestParam() {
        // "A,A|A,A,0|A"
        return this.dataStore.map(group => {
            const adults = Array(group.adults).fill('A')
            const childrenAges = group.children ??= []
            return [...adults, ...childrenAges].join(',')
        }).join('|')

    }


}

export default RoomAllocationsControl